// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class Team  {
    _originalTypeClassName = "Loom.BO.Team";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Team.translate = translateService;
}
this.Members = [];
this.Id = null;
this.Name = null;
this.CreatedOn = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
CreatedOn:any;
Leader:any;
Members:any;
Organisation:any;
CreatedBy:any;
static setLeader = ($this, value) => {
var oldValue = $this.Leader;
$this.Leader = value;
if (value != null) {
if (oldValue != null) {
Domain.Person.removeLeaderOf(oldValue, $this);
}
Domain.Person.addLeaderOf(value, $this);
}
}
static setMembers = ($this, items) => {
                if (items == null) items = [];
                if ($this.Members == null) $this.Members = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Members.length > 0) {
                    Domain.Team.removeMembers($this, $this.Members[0]);
                }

                Domain.Team.addManyMembers($this, copyItems);
            }
static addManyMembers = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Team.addMembers($this, items[i]);
                }
            }
static addMembers = ($this, item) => {
                if ($this.Members == null) $this.Members = [];
                if (item == null || $this.Members.indexOf(item) > -1) return;
                $this.Members.push(item);
Domain.Person.addMemberOf(item, $this);
}
static addRangeMembers = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Team.addMembers($this, item));
            }
static removeMembers = ($this, item) => {
                if ($this == null || $this.Members == null || $this.Members.indexOf(item) === -1) return;
                var _index = $this.Members.indexOf(item);
                $this.Members.splice(_index, 1);
Domain.Person.removeMemberOf(item, $this);
}
static clearMembers = ($this) => { $this.Members = null; }
static setOrganisation = ($this, value) => {
var oldValue = $this.Organisation;
$this.Organisation = value;
if (value != null) {
}
}
static setCreatedBy = ($this, value) => {
var oldValue = $this.CreatedBy;
$this.CreatedBy = value;
if (value != null) {
if (oldValue != null) {
Domain.Person.removeTeamsCreated(oldValue, $this);
}
Domain.Person.addTeamsCreated(value, $this);
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}